import { defineMessages } from 'react-intl';

export const fullscreenFormPreviewModalMessages = defineMessages({
  loadingPdfViewer: {
    defaultMessage: 'Loading PDF viewer...',
    id: 'C3QeOCJc7t',
    description: 'Loading state shown while the PDF viewer chunk is fetched',
  },
  resetZoom: {
    defaultMessage: 'Reset zoom to 100%',
    id: 'A5u/6M0aA0',
    description: 'Accessibility label for the button that resets PDF zoom to default',
  },
  downloadButton: {
    defaultMessage: 'Download',
    id: 'hyW50QMWAm',
    description: 'Label for the button that downloads the PDF preview',
  },
  downloadAria: {
    defaultMessage: 'Download',
    id: '92tjCUBwKU',
    description: 'Accessible label for the button that downloads the PDF preview',
  },
  canStillBeUsedAsTemplate: {
    defaultMessage: 'This PDF can still be used as a template',
    id: '/n+NocHtec',
    description: 'Secondary message when a PDF preview fails to load in the modal',
  },
});
